import { render, staticRenderFns } from "./ExcludedUsers.vue?vue&type=template&id=1d33bb93"
import script from "./ExcludedUsers.vue?vue&type=script&lang=js"
export * from "./ExcludedUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports